import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { GetZipCode, ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import States from "../../../../utils/Constants"
import { Credentials } from "../../../../utils/Constants"
import Loader from "../../../shared/Loader/Loader"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import NpiRegistry from "../../../General/NpiRegistry"
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import handleAlphabeticCheck from "../../../../utils/HandleAlphabetKeys"
import ReactInputMask from "react-input-mask"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import { useSelector } from "react-redux"
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber"
import Draggable from "react-draggable"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import SignEncounter from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter"
import DatePicker from "../../../General/DatePicker"
import { SketchPicker } from "react-color"
import reactCSS from "reactcss"
const AddNewProvider = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Provider')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Provider')?.IsDeleted
    const providerIDs = { ...props };

    const BilUnder = [
        { value: '', display: 'Select Type' },
        { value: 'Provider', display: 'Provider' },
        { value: 'Practice/Billing Provider', display: 'Practice/Billing Provider' },
    ]
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        ProviderLNameVal: "",
        ProviderFNameVal: "",
        MIVal: "",
        NPIVal: "",
        SSNVal: "",
        TaxonomyCodeVal: "",
        AddressLine1Val: "",
        AddressLine2Val: "",
        CityVal: "",
        StateVal: "",
        ZipCodeVal: "",
        PayToZipCodeLengthVal: "",
        NPILengthVal: "",
        SSNLengthVal: "",
        ZipCodeLengthVal: "",
        EmailAddressVal: "",
        ContactNumberLenghtVal: "",
        ZipCodeDigitVal: "",
        InactiveDateVal: "",
        ReportingProviderIDVal: "",
        colorVal: '',
    }
    let Provider_Modal = {
        // PracticeID: 113,
        LastName: "",
        FirstName: "",
        ProviderName: "",
        MI: "",
        Credential: "",
        NPI: "",
        TaxonomyCode: "",
        SSN: "",
        BillUnder: "",
        EligibilityUnder: "",
        ClaimStatusUnder: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactPersonName: '',
        ContactPhoneNumber: '',
        EmailAddress: "",
        FaxNumber: "",
        Website: "",
        DEANum: "",
        MedicareNum: "",
        MedicaidNum: "",
        BlueSheildNum: "",
        BlueCrossNum: "",
        CommercialNum: "",
        ChampusNum: "",
        StateLicenseNumber: '',
        PayToAddressLine1: "",
        PayToAddressLine2: "",
        PayToCity: "",
        PayToState: "",
        PayToZipCode: "",
        Active: true,
        InactiveDate: null,
        IsLocumProvider: false,
        ReportingProviderID: "",
        ColorCode: ""
    }
    const [printoutModal, setPrintOutModal] = useState(false)
    const [is, setIs] = useState(false);
    const [providerID, setproviderID] = useState(0)
    const [providerValidationModal, setProviderValidationModal] = useState(ValidationModal)
    let [providerSaveUpdateModal, setProviderSaveUpdateModal] = useState({})
    const [mainProvidereModal, setmainProvidereModal] = useState(Provider_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState();
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [del, setDel] = useState(false)
    const [statesValue, setStatesValue] = useState({ value: '', display: '' })
    const [PaytoStateValue, setPaytoStateValue] = useState({ value: '', display: '' })
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // auto complete 
    const API_URL = enumUtil.controller.General
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    const { isOpenProvider, onClose, onDeleteProvider, npiModal, proceedHeader, onCloseProocedNpi, type } = { ...props }
    const [TaxonomyCode, setTaxonomyCode] = useState({ Code: '', MedicareSpecialityCode: '' })
    const [onProviderSaved, setOnProviderSaved] = useState(false)
    const [selectedClassification, setSelectedClassification] = useState('');
    const [errorOnPaste, seterrorOnPaste] = useState(false)
    const [isSign, setIsSign] = useState(false);
    const [imgFile, setImgFile] = useState(null);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let ADC = DropDowns?.IsAdultDayCare
    let Homecare = DropDowns?.IsHomeCare
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState("")

    useEffect(() => {
        // right now, use any providerid to test update case/find by id
        if (props.ProviderID != null) {
            setproviderID(props.ProviderID)
            setDel(true)
        } else {
            if (!onProviderSaved) {
                setproviderID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(providerID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": providerID,
                "TableName": enumUtil.enumAPITableName.Provider

            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                response.ReportingProviderID = DropdownValueHandler(DropDowns?.Provider, response.ReportingProviderID)

                response.Credential = DropdownValueHandler(Credentials, response.Credential)

                response.PayToState = DropdownValueHandler(States, response.PayToState)
                if (!isNull(response.ContactPhoneNumber)) {
                    response.ContactPhoneNumber = FormatPhoneNumber(response.ContactPhoneNumber)
                }
                setColor(response?.ColorCode === null ? response.ColorCode = "" : response.ColorCode)
                ViewFile(response?.SignaturePath);
                setmainProvidereModal(response)
                setSelectedClassification(response.ClassificationSpecialization);
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [providerID])
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainProvidereModal };
        let saveModal = { ...providerSaveUpdateModal }
        modal[type] = FormatedDate
        // if (type === 'InactiveDate') {
        //     modal['InactiveDate'] = calculateAge(date)
        // }
        setmainProvidereModal(modal)
        for (var property in Provider_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setProviderSaveUpdateModal(saveModal)
    }
    const handleProviderChange = (e) => {
        setIs(true)
        let { name, value, checked } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainProvidereModal };
        let saveModal = { ...providerSaveUpdateModal }

        if (name === 'ContactPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainProvidereModal(prevState => ({ ...prevState, ...data?.main }));
                    setProviderSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else if (name === 'PayToZipCode') {
            GetZipCode(value)
                .then(data => {
                    modal.PayToState = data.main.State
                    modal.PayToCity = data.main.City
                    setmainProvidereModal(prevState => ({ ...prevState, PayToCity: data.main.City, PayToState: data.main.State }));
                    saveModal.PayToState = data.save.State
                    saveModal.PayToCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else if (name === "Active") {
            modal[name] = checked;
            if (checked === true) {
                modal.InactiveDate = null;
                // saveModal.InactiveDate = null;     
            }
        }
        else if (name === 'IsLocumProvider') {
            modal[name] = !modal[name]
        }
        else {
            modal[name] = value;
        }
        setmainProvidereModal(modal)
        for (var property in Provider_Modal) {
            if (name === property) {
                if (name === 'Active') {

                    saveModal[name] = checked + "";
                    if (checked === true || checked === 'true') {
                        saveModal.InactiveDate = null;
                    }
                }
                else if (name === 'IsLocumProvider') {
                    saveModal[name] = modal[name] + ""
                }

                else {
                    saveModal[name] = value
                }

            }
        }
        setProviderSaveUpdateModal(saveModal)

    }
    const handleProviderChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainProvidereModal };
        modal[name] = value
        setmainProvidereModal(modal)
    }
    const handleChange = (color) => {
        let name = "ColorCode";
        let value = color?.hex;
        let modal = { ...mainProvidereModal };
        let saveModal = { ...providerSaveUpdateModal };
        setColor(color.hex);
        modal[name] = value;
        setmainProvidereModal(modal);
        for (var property in Provider_Modal) {
            if (name === property) {
                saveModal[name] = value;
            }
        }
        setProviderSaveUpdateModal(saveModal);
    };
    // validate Practice Modal 
    const ProviderValidation = async () => {
        let PhoneNumber;
        let faxNumber;
        if (!isNull(mainProvidereModal.ContactPhoneNumber)) {
            PhoneNumber = mainProvidereModal.ContactPhoneNumber.replace(/[()-\s]/g, '');
        }
        if (mainProvidereModal.FaxNumber !== null) {
            faxNumber = mainProvidereModal.FaxNumber.replace(/-/g, "");
        }
        let ValidationModal = {
            ProviderLNameVal: FormValidator(
                mainProvidereModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            ProviderFNameVal: FormValidator(
                mainProvidereModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            // MIVal: FormValidator(
            //     mainProvidereModal.MI,
            //     enumUtil.enumValidationType.Required,
            //     'MI',
            // ),
            NPIVal: FormValidator(
                mainProvidereModal.NPI,
                enumUtil.enumValidationType.Required,
                'NPI',
            ),
            // SSNVal: FormValidator(
            //     mainProvidereModal.SSN,
            //     enumUtil.enumValidationType.Required,
            //     'SSN',
            // ),
            WebsiteVal: FormValidator(
                mainProvidereModal.Website,
                enumUtil.enumValidationType.Website,
                'Website',
            ),
            // TaxonomyCodeVal: FormValidator(
            //     mainProvidereModal.TaxonomyCode,
            //     enumUtil.enumValidationType.Required,
            //     'Taxonomy Code',
            // ),
            // AddressLine1Val : FormValidator(
            //     mainProvidereModal.AddressLine1,
            //     enumUtil.enumValidationType.Required,
            //     'Address',
            // ),
            // AddressLine2Val : FormValidator(
            //     mainProvidereModal.AddressLine2,
            //     enumUtil.enumValidationType.Required,
            //     'Address',
            // ),
            // CityVal : FormValidator(
            //     mainProvidereModal.City,
            //     enumUtil.enumValidationType.Required,
            //     'City',
            // ),
            // StateVal: FormValidator(
            //     mainProvidereModal.State,
            //     enumUtil.enumValidationType.Required,
            //     'State',
            // ),
            // ZipCodeVal: FormValidator(
            //     mainProvidereModal.ZipCode,
            //     enumUtil.enumValidationType.Required,
            //     'Zip Code',
            // ),
            NPILengthVal: FormValidator(
                mainProvidereModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            SSNLengthVal: FormValidator(
                mainProvidereModal.SSN,
                enumUtil.enumValidationType.Length,
                'SSN',
                9
            ),
            ZipCodeLengthVal: FormValidator(
                mainProvidereModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            PayToZipCodeLengthVal: FormValidator(
                mainProvidereModal.PayToZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            EmailAddressVal: FormValidator(
                mainProvidereModal.EmailAddress,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            ZipCodeDigitVal: FormValidator(
                mainProvidereModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code',
            ),
            colorVal: ADC === 'true' || Homecare === 'true' ? null : FormValidator(
                mainProvidereModal.ColorCode,
                enumUtil.enumValidationType.Required,
                'Color',
            ),

            // InactiveDateVal: FormValidator(
            //     mainProvidereModal.InactiveDate,
            //     enumUtil.enumValidationType.Required,
            //     'Inactive Date',
            // ),
            InactiveDateVal: mainProvidereModal.Active === true
                ? null
                : FormValidator(
                    mainProvidereModal.InactiveDate,
                    enumUtil.enumValidationType.Required,
                    'InActive Date',
                ),
            ReportingProviderIDVal: mainProvidereModal.IsLocumProvider === false
                ? null
                : FormValidator(
                    mainProvidereModal.ReportingProviderID,
                    enumUtil.enumValidationType.Required,
                    'Reporting Provider ',
                ),


        }
        await setProviderValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveProvider = async () => {
        // if (providerID == null) {
        //     setproviderID("");
        // }

        await ProviderValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            if (providerSaveUpdateModal.FaxNumber != null) {
                providerSaveUpdateModal['FaxNumber'] = providerSaveUpdateModal.FaxNumber.replace(/-/g, "");
            }
            if (providerSaveUpdateModal.ContactPhoneNumber != null) {
                providerSaveUpdateModal['ContactPhoneNumber'] = providerSaveUpdateModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
                providerSaveUpdateModal.ContactPhoneNumber = providerSaveUpdateModal.ContactPhoneNumber.slice(0, 10);
            }
            setProviderSaveUpdateModal(providerSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Provider,
                ID: providerID,
                data: { ...providerSaveUpdateModal, Active: mainProvidereModal?.Active === true ? 'true' : 'false' },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    setIsLoading(false)
                    UpdateReduxDropDowns(providerID, DropDowns.Provider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)
                    // UpdateReduxDropDowns(providerID, DropDowns.RefProvider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)
                    // UpdateReduxDropDowns(providerID, DropDowns.BillingProvider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)

                    // if (providerID === 0) {
                    //     let obj = { value: response.id - "", display: mainProvidereModal.LastName + mainProvidereModal.FirstName }
                    //     DropDowns.Provider.push(obj)
                    //     DropDowns.RefProvider.push(obj)
                    //     DropDowns.BillingProvider.push(obj)
                    // }else{
                    //     DropDowns.Provider.map((item) => {
                    //         if(item.value+"" ===  response.id){
                    //             item.display = mainProvidereModal.LastName + ' , '+ mainProvidereModal.FirstName
                    //         }
                    //     })
                    // }
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    setproviderID(response.id)
                    setOnProviderSaved(true)
                    onDeleteProvider()
                    // Setting Save model to null
                    //setProviderSaveUpdateModal('')
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const SetProviderName = () => {
        if (mainProvidereModal.LastName != null && mainProvidereModal.LastName != "") {
            return (
                <p className="heading sm">{mainProvidereModal.LastName}{' '}{mainProvidereModal.FirstName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Provider</p>
            )
        }
    }
    const handleNpiRegistry = () => {
        if (mainProvidereModal.NPI != undefined) {
            setNpiRegistryNumber(mainProvidereModal.NPI)
        }
        setIsOpenRegistry(true);
        setIsLoading(false);
        onCloseProocedNpi();
    }
    const CloseRegistry = (data) => {
        setIs(true)
        mainProvidereModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainProvidereModal.FirstName
        mainProvidereModal.LastName = !isNull(data.LastName) ? data.LastName : mainProvidereModal.LastName
        mainProvidereModal.ContactPersonName = data.ContactPersonName
        mainProvidereModal.AddressLine1 = data.AddressLine1
        mainProvidereModal.AddressLine2 = data.AddressLine2
        mainProvidereModal.City = data.City
        mainProvidereModal.State = DropdownValueHandler(States, data.State)
        // mainProvidereModal.State = data.State
        mainProvidereModal.ZipCode = data.ZipCode
        mainProvidereModal.ContactPhoneNumber = data.ContactPhoneNumber
        mainProvidereModal.PayToAddressLine1 = data.PayToAddressLine1
        mainProvidereModal.PayToAddressLine2 = data.PayToAddressLine2
        mainProvidereModal.PayToCity = data.PayToCity
        mainProvidereModal.PayToState = DropdownValueHandler(States, data.PayToState)
        // mainProvidereModal.PayToState = data.PayToState
        mainProvidereModal.PayToZipCode = data.PayToZipCode
        mainProvidereModal.NPI = data.NPI
        mainProvidereModal.TaxonomyCode = data.TaxonomyCode
        //SaveUpdateModal
        providerSaveUpdateModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainProvidereModal.FirstName
        providerSaveUpdateModal.LastName = !isNull(data.LastName) ? data.LastName : mainProvidereModal.LastName
        // setTaxonomyCode({ Code: data.TaxonomyCode, MedicareSpecialityCode: data.MedicareSpecialityCode })
        providerSaveUpdateModal.TaxonomyCode = data.TaxonomyCode
        providerSaveUpdateModal.ContactPersonName = data.ContactPersonName
        providerSaveUpdateModal.AddressLine1 = data.AddressLine1
        providerSaveUpdateModal.AddressLine2 = data.AddressLine2
        providerSaveUpdateModal.City = data.City
        providerSaveUpdateModal.State = data.State
        providerSaveUpdateModal.ZipCode = data.ZipCode
        const formattedcontactNumber = !isNull(data.ContactPhoneNumber) ? FormatPhoneNumber(data.ContactPhoneNumber) : ''
        mainProvidereModal.ContactPhoneNumber = formattedcontactNumber
        providerSaveUpdateModal.ContactPhoneNumber = formattedcontactNumber
        providerSaveUpdateModal.PayToAddressLine1 = data.PayToAddressLine1
        providerSaveUpdateModal.PayToAddressLine2 = data.PayToAddressLine2
        providerSaveUpdateModal.PayToCity = data.PayToCity
        providerSaveUpdateModal.PayToState = data.PayToState
        providerSaveUpdateModal.PayToZipCode = data.PayToZipCode
        providerSaveUpdateModal.NPI = data.NPI
        providerSaveUpdateModal.TaxonomyCode = data.TaxonomyCode

        setIsOpenRegistry(false)
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseNpi = () => {
        setIsOpenRegistry(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Provider} ID={providerID} onClose={onDeleteProvider} dropDown={DropDowns.Provider} />
    }
    let PopupScreen = "";
    if (isOpenRegistry) {
        PopupScreen = <NpiRegistry isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} ClassName='npi-panel npi-open npi_detail_popup' />
    }
    ///////Super Search////////
    const getTaxonomyCodeSelected = (selectedData, name, type) => {
        if (!isNull(selectedData)) {
            if (type === 'client') {
                if (name === 'State') {
                    // LocationSaveUpdateModal[name] = selectedData.selectedData
                    // setStatesValue(selectedData.display)
                }
            } else if (type === 'server') {
                if (name === 'TaxonomyCode') {
                    setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: selectedData.Code })
                    providerSaveUpdateModal['TaxonomyCode'] = selectedData.Code
                    setSelectedClassification(selectedData.ClassificationSpecialization);
                }
            }
        } else {
            if (name === "TaxonomyCode") {
                setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: '' })
                providerSaveUpdateModal['TaxonomyCode'] = ''
                setSelectedClassification('');
            }
        }
        return selectedData
    }
    ///////////////
    const handleAuditModal = () => {
        // alert('asdas')
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={providerID + ""} TableName={enumUtil.enumAPITableName.Provider} />
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainProvidereModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'State') {
                modal[name] = selectedData.display
                providerSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'PayToState') {
                modal[name] = selectedData.display
                providerSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'Credential') {
                modal[name] = selectedData.display
                providerSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'ReportingProviderID') {
                modal[name] = selectedData.display
                providerSaveUpdateModal[name] = selectedData.value + "";
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'POSCode') {
                // practiceSaveUpdateModal[name] = selectedData.ID
                // setSearchValue(selectedData.ID)
            }
        } else {
            modal[name] = ''
            providerSaveUpdateModal[name] = ''
        }
        setmainProvidereModal(modal)

        return selectedData
    }
    const [modalImg, setModalImg] = useState(null)
    const handleOpenImg = (type) => {
        // console.log("isSignUploadedhandleOpenImg", isSignUploaded)
        let isSignUploaded = mainProvidereModal?.SignatureFileName?.includes('uploaded-signature');
        if (!isSignUploaded) return;

        if (type === 'unsaved') {
            setModalImg(`data:image/png;base64,${providerSaveUpdateModal.SignaturePath}`);
        } else {
            setModalImg(imgFile)
        }

        setPrintOutModal(true)
    }
    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);

    };
    const handleClose = () => {
        setDisplayColorPicker(false);
    };
    const styles = reactCSS({
        'default': {
            color: {
                background: color,
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });
    const AddNewProvModalBody = () => {
        return (
            <div className="d-flex fa-layout h-100">
                <div className="form-col w-35 pb-2">
                    <div className="pe-4">
                        <div className=" form-group input ">
                            <label htmlFor="LastName">Last Name <span className='req'>*</span></label>
                            <div className={providerValidationModal.ProviderLNameVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="LastName"
                                    id="LastName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainProvidereModal.LastName}
                                    onChange={handleProviderChange}
                                />
                                {providerValidationModal.ProviderLNameVal}
                            </div>
                            {/* error helperText="Error Message" */}
                        </div>
                        <div className=" form-group input ">
                            <label htmlFor="FirstName">First Name <span className='req'>*</span></label>
                            <div className={providerValidationModal.ProviderFNameVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="FirstName"
                                    id="FirstName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainProvidereModal.FirstName}
                                    onChange={handleProviderChange}
                                />
                                {providerValidationModal.ProviderFNameVal}
                            </div>
                        </div>
                        <div className={providerValidationModal.MIVal ? 'form-group input error' : 'form-group input'}>
                            <label htmlFor="MI">MI</label>
                            <input type="text"
                                className='form-control'
                                name="MI"
                                id="MI"
                                autoComplete="off"
                                maxLength={3}
                                value={mainProvidereModal.MI}
                                onChange={handleProviderChange}
                                onKeyPress={(event) => handleAlphabeticCheck(event)}
                            />
                            {providerValidationModal.MIVal}
                        </div>

                        <div className="form-group input">
                            <div className='input'>
                                <label htmlFor="Credential">Credential</label>
                                <SuperSearchList
                                    name="Credential"
                                    id="Credential"
                                    data={Credentials}
                                    searchValue={mainProvidereModal.Credential}
                                    onChange={handleProviderChange}
                                    sup_btn={'sup_btn-Inp'}
                                    sup_inp={'superSearchVisitInp'}
                                    getSelectedData={(searchValue) => handleSelectedData(searchValue, 'Credential', 'client')}
                                    is={is}
                                />
                            </div>
                            <div className=" form-group input ">
                                <label htmlFor="NPI">NPI<span className='req'>*</span></label>
                                <div className={providerValidationModal.NPIVal ? 'input error' : providerValidationModal.NPILengthVal ? 'input error' : 'input'}>
                                    <div className='field-icon'>
                                        <input type="text"
                                            className='form-control'
                                            name="NPI"
                                            id="NPI"
                                            autoComplete="off"
                                            maxLength={10}
                                            value={mainProvidereModal.NPI}
                                            onChange={handleProviderChange}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        <div className='last'>
                                            <div className="app_tooltip left" onClick={handleNpiRegistry}>
                                                <div className='NPI-R-circle'>R</div>
                                                <p className="tool_tip xsm_text text-light">NPI Registry</p>
                                            </div>
                                        </div>
                                    </div>
                                    {providerValidationModal.NPIVal ? providerValidationModal.NPIVal : providerValidationModal.NPILengthVal}
                                </div>
                            </div>
                            <div className=" form-group input ">
                                <label htmlFor="TaxonomyCode">Taxonomy Code</label>
                                <div className='form-group input'>
                                    <SuperSearch
                                        ApiLink={API_URL + "/InstantSearch"}
                                        method="post"
                                        postBody={{
                                            "TableName": enumUtil.enumAPITableName.Taxonomy,
                                            "SearchParam": mainProvidereModal.TaxonomyCode,
                                        }}
                                        tableHeight={400}
                                        tableWidth="400px"
                                        id={'TaxonomyCode'}
                                        getSelectedData={(value) => getTaxonomyCodeSelected(value, "TaxonomyCode", "server")}
                                        onChange={(e) => setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: e.target.value })}
                                        searchValue={mainProvidereModal.TaxonomyCode}
                                        tableData={[
                                            // { columName: 'ID', bindingValue: 'TaxonomyID', },
                                            { columName: 'Code', bindingValue: 'Code', },
                                            { columName: 'Medicare Speciality Code', bindingValue: 'MedicareSpecialityCode', },
                                        ]}
                                        disabled={false}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                            <div className="form-group input yellow-box">
                                <p className="mb-0">{selectedClassification} </p>
                            </div>
                            <div className="form-group input">
                                <label htmlFor="SSN">SSN<span className='req'></span></label>
                                <div className={providerValidationModal.SSNLengthVal ? 'input error' : 'input'}>
                                    <input type="text"
                                        className='form-control'
                                        name="SSN"
                                        id="SSN"
                                        maxLength={9}
                                        autoComplete="off"
                                        value={mainProvidereModal.SSN}
                                        onChange={handleProviderChange}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                    />
                                    {providerValidationModal.SSNVal ? providerValidationModal.SSNVal : providerValidationModal.SSNLengthVal}
                                </div>
                            </div>
                            {ADC === 'true' || Homecare === 'true' ? <></> :

                                <div className={providerValidationModal.colorVal ? 'form-group input error' : 'form-group input'}>
                                    <label for="lastName">Color Code <span className='req'>*</span></label>
                                    <div>
                                        <div className="YM-color-picker" onClick={handleClick}>
                                            <div style={styles.color} />
                                        </div>
                                        {displayColorPicker ?
                                            <div className="location_clr" style={styles.popover}>
                                                <div style={styles.cover} onClick={handleClose} />
                                                <SketchPicker
                                                    id='ColorCode'
                                                    name='ColorCode'
                                                    value={mainProvidereModal.ColorCode}
                                                    color={color}
                                                    onChange={(color) => handleChange(color, mainProvidereModal.ColorCode)}
                                                />
                                            </div> : null}
                                    </div>
                                    {providerValidationModal.colorVal}
                                </div>
                            }
                            <div className="form-group input">
                                {/* {mainProvidereModal.SignatureFileName ?} */}
                                {/* <label htmlFor="SSN" className="cursor-pointer" onClick={() => setIsSign(true)}>Click here to sign<span className='req'></span></label> */}

                                <div className="position-relative sign-here-box provider-sign-box cursor-pointer d-flex align-items-center justify-content-center h-100 py-3">
                                    {!isNull(imgFile) ?
                                        <>
                                            <div onClick={() => handleOpenImg()}>
                                                <img
                                                    src={imgFile}
                                                    style={{ maxHeight: '81px' }}
                                                    className="mw-100 px-2"
                                                    alt="Uploaded preview" />
                                            </div>
                                            <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                            </span>
                                        </>
                                        :
                                        (providerSaveUpdateModal.SignaturePath ?
                                            <div onClick={() => handleOpenImg("unsaved")}>
                                                <img
                                                    src={`data:image/png;base64,${providerSaveUpdateModal.SignaturePath}`}
                                                    style={{ maxHeight: '81px' }}
                                                    className="mw-100 px-2"
                                                    alt="Uploaded preview" />
                                                <span className="cross-icon d-flex" onClick={(e) => {
                                                    e.stopPropagation(); // prevent parent click
                                                    handleRemoveFile();
                                                }}>
                                                    <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                </span>
                                            </div> :
                                            (mainProvidereModal.SignaturePath && !imgFile && !isLoading) ?
                                                <>
                                                    <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => ViewFile(mainProvidereModal.SignaturePath)}>Signature failed to load. Click to reload.</div>
                                                    <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                        <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                    </span>
                                                </> :
                                                <div className='fs-13 ar-light-color text h-100 w-100 d-flex justify-content-center align-items-center' onClick={() => setIsSign(true)}>
                                                    {/* {!isLoading ? 'Click to add signature...' : ''} */}
                                                    Click to add signature...</div>)}
                                </div>
                            </div>
                            <div className='d-flex gap-1 align-items-center m-0 ar-toggle mb-12'>
                                <p className='fs-11 text font-m lh-11'>Active</p>
                                <div class="pe-0 m-0 insurance_radio_btn">
                                    <div class="form-check form-switch radio_button mh-unset m-0">
                                        <input
                                            class="form-check-input m-0"
                                            type="checkbox"
                                            id="mySwitch"
                                            name="Active"
                                            // checked={item?.IsActive}
                                            checked={mainProvidereModal.Active === true}
                                            onChange={e => handleProviderChange(e)}
                                        // onChange={e => handleIsActiveChange(e.target.checked, item.RecordID)}

                                        // defaultChecked onClick={() => handleIsActiveChange(item.RecordID)}
                                        />
                                    </div>
                                </div>
                            </div>
                            {mainProvidereModal.Active === false ? <>

                                <div className={providerValidationModal.InactiveDateVal ? 'form-group input error' : 'form-group input'}>
                                    <label htmlFor="InactiveDate">InActive Date  <span className='req'>*</span></label>
                                    <DatePicker
                                        id="InactiveDate"
                                        value={mainProvidereModal.InactiveDate}
                                        handleCalendarChangefunc={date => handleCalendarChange(date, 'InactiveDate')}
                                    />
                                    {providerValidationModal.InactiveDateVal}

                                </div>
                            </> : <></>}

                            <div className="check_box mb-12">
                                <div className="custom_check_box d-flex gap-1 align-items-center">
                                    <input
                                        className="form-check-input p-0 mt-0"
                                        type="checkbox"
                                        id="IsLocumProvider"
                                        name="IsLocumProvider"
                                        autoComplete="off"
                                        checked={mainProvidereModal.IsLocumProvider}
                                        onChange={(e) => handleProviderChange(e)}
                                    />
                                    <label className="form-check-label heading font-m" for="IsLocumProvider">
                                        Locum Provider
                                    </label>
                                </div>
                            </div>


                            {mainProvidereModal?.IsLocumProvider ?
                                <div className="form-group input m-0 mb-12">
                                    <div className={providerValidationModal.ReportingProviderIDVal ? 'form-group input error m-0' : 'form-group input m-0'}>
                                        <label htmlFor="" className="">Reporting Provider<span className='req'>*</span></label>
                                        <SuperSearchList
                                            type="client"
                                            id='ReportingProviderID'
                                            name='ReportingProviderID'
                                            searchValue={mainProvidereModal.ReportingProviderID}
                                            data={DropDowns?.Provider}
                                            onChange={handleProviderChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={providerValidationModal.ReportingProviderIDVal}
                                        />
                                        {providerValidationModal.ReportingProviderIDVal}
                                    </div>
                                </div>
                                : null}

                        </div>
                    </div>
                </div>
                <div className="accordian-col w-65 pb-2">
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Provider1-header"
                                aria-controls="Provider1-content"
                            >
                                <p className="heading">Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        {/* <div className={providerValidationModal.AddressLine1Val ?'input error':'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">Address Line 1</label>
                                            <input type="text" className='form-control'
                                                name="AddressLine1"
                                                id="AddressLine1"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.AddressLine1}
                                                onChange={handleProviderChange}
                                            />
                                            {/* {providerValidationModal.AddressLine1Val} */}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {/* <div className={providerValidationModal.AddressLine2Val ?'input error':'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">Address Line 2</label>
                                            <input type="text" className='form-control'
                                                name="AddressLine2"
                                                id="AddressLine2"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.AddressLine2}
                                                onChange={handleProviderChange}
                                            />
                                            {/* {providerValidationModal.AddressLine2Val} */}
                                        </div>
                                    </div>
                                </div>
                                <div className='row row-gap-15 row-half mt-3'>
                                    <div className="col-md-6">
                                        {/* <div className={LocationValidationModal.CityVal ? 'input error' : 'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">City</label>
                                            <input type="text" className='form-control'
                                                name="City"
                                                id="City"
                                                autoComplete="off"
                                                maxLength={30}
                                                value={mainProvidereModal.City}
                                                onChange={handleProviderChange}
                                            />
                                            {/* {providerValidationModal.CityVal} */}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        {/* <div className={providerValidationModal.StateVal ?'input error':'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='State'
                                                name='State'
                                                searchValue={mainProvidereModal.State}
                                                data={States}
                                                onChange={handleProviderChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />
                                            {/* <Autocomplete
                                            id="State"
                                            disableClearable={true}
                                            value={statesValue}
                                            options={States}
                                            onChange={(event, value) => handleDropDownChange(value, 'State')}
                                            getOptionLabel={(option) => option.display}
                                            noOptionsText={"Not Available"}
                                            renderInput={(params) => <TextField {...params} variant="standard" />}
                                        /> */}
                                            {/* {providerValidationModal.StateVal} */}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label htmlFor="">Zip Code</label>
                                            <div className={providerValidationModal.ZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                <input type="text" className='form-control'
                                                    name="ZipCode"
                                                    id="ZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainProvidereModal.ZipCode}
                                                    onChange={handleProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {providerValidationModal.ZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Provider2-header"
                                aria-controls="Provider2-content"
                            >
                                <p className="heading">Contact Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Name</label>
                                            <input type="text" className='form-control'
                                                name="ContactPersonName"
                                                id="ContactPersonName"
                                                autoComplete="off"
                                                maxLength={35}
                                                value={mainProvidereModal.ContactPersonName}
                                                onChange={handleProviderChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Contact Number</label>
                                            <div className={providerValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    autoComplete="off"
                                                    placeholder="(555) 555-5555"
                                                    name="ContactPhoneNumber"
                                                    id="ContactPhoneNumber"
                                                    value={mainProvidereModal.ContactPhoneNumber}
                                                    onChange={handleProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)} />
                                                {providerValidationModal.ContactNumberLenghtVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Email Address</label>
                                            <div className={providerValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    maxLength={100}
                                                    autoComplete="off"
                                                    name="EmailAddress"
                                                    id="EmailAddress"
                                                    value={mainProvidereModal.EmailAddress}
                                                    onChange={handleProviderChange}
                                                />
                                                {providerValidationModal.EmailAddressVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Website</label>
                                            <div className={providerValidationModal.WebsiteVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    maxLength={200}
                                                    name="Website"
                                                    id="Website"
                                                    autoComplete="off"
                                                    value={mainProvidereModal.Website}
                                                    onChange={handleProviderChange}
                                                />
                                                {providerValidationModal.WebsiteVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={providerValidationModal.FaxNumberLengthVal ? 'form-group input error' : 'form-group input'}>
                                            <label htmlFor="">Fax Number</label>
                                            <ReactInputMask type="text"
                                                className='form-control'
                                                maskChar={0}
                                                mask='999-999-9999'
                                                autoComplete="off"
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                name="FaxNumber"
                                                id="FaxNumber"
                                                value={mainProvidereModal.FaxNumber}
                                                onChange={handleProviderChange}
                                            />
                                            {providerValidationModal.FaxNumberLengthVal}
                                        </div>
                                    </div>

                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Provider3-header"
                                aria-controls="Provider3-content"
                            >
                                <p className="heading">Pay to Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 1</label>
                                            <input type="text" className='form-control'
                                                name="PayToAddressLine1"
                                                id="PayToAddressLine1"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.PayToAddressLine1}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 2</label>
                                            <input type="text" className='form-control'
                                                name="PayToAddressLine2"
                                                id="PayToAddressLine2"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.PayToAddressLine2}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row row-gap-15 row-half mt-3'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">City</label>
                                            <input type="text" className='form-control'
                                                name="PayToCity"
                                                id="PayToCity"
                                                autoComplete="off"
                                                maxLength={30}
                                                value={mainProvidereModal.PayToCity}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label htmlFor="">State</label>
                                            {/* <Autocomplete
                                            id="State"
                                            disableClearable={true}
                                            value={statesValue}
                                            options={States}
                                            onChange={(event, value) => handleDropDownChange(value, 'State')}
                                            getOptionLabel={(option) => option.display}
                                            noOptionsText={"Not Available"}
                                            renderInput={(params) => <TextField {...params} variant="standard" />}
                                        /> */}

                                            <SuperSearchList
                                                type="client"
                                                id='PayToState'
                                                name='PayToState'
                                                searchValue={mainProvidereModal.PayToState}
                                                data={States}
                                                onChange={handleProviderChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />
                                            {/* <Autocomplete
                                            id="PaytoState"
                                            disableClearable={true}
                                            value={PaytoStateValue}
                                            options={States}
                                            onChange={(event, value) => handleDropDownChange(value, 'PayToState')}
                                            getOptionLabel={(option) => option.display}
                                            noOptionsText={"Not Available"}
                                            renderInput={(params) => <TextField {...params} variant="standard" />}
                                        /> */}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label htmlFor="">Zip Code</label>
                                            <div className={providerValidationModal.PayToZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                <input type="text" className='form-control'
                                                    name="PayToZipCode"
                                                    id="PayToZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainProvidereModal.PayToZipCode}
                                                    onChange={handleProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}

                                                />
                                                {providerValidationModal.PayToZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Provider4-header"
                                aria-controls="Provider4-content"
                            >
                                <p className="heading">Provider ID</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label>Medicare#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                autoComplete="off"
                                                name="MedicareNum"
                                                id="MedicareNum"
                                                value={mainProvidereModal.MedicareNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label>Medicaid#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                name="MedicaidNum"
                                                id="MedicaidNum"
                                                autoComplete="off"
                                                value={mainProvidereModal.MedicaidNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label>Blue Shield#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                name="BlueSheildNum"
                                                autoComplete="off"
                                                id="BlueSheildNum"
                                                value={mainProvidereModal.BlueSheildNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label>Blue Cross#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                name="BlueCrossNum"
                                                id="BlueCrossNum"
                                                autoComplete="off"
                                                value={mainProvidereModal.BlueCrossNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label>Commercial#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                autoComplete="off"
                                                name="CommercialNum"
                                                id="CommercialNum"
                                                value={mainProvidereModal.CommercialNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div><div className="col-md-3">
                                        <div className='input'>
                                            <label>Champus#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                name="ChampusNum"
                                                autoComplete="off"
                                                id="ChampusNum"
                                                value={mainProvidereModal.ChampusNum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div><div className="col-md-3">
                                        <div className='input'>
                                            <label>State License#</label>
                                            <input type="text"
                                                maxLength={50}
                                                className="form-control"
                                                name="StateLicenseNumber"
                                                id="StateLicenseNumber"
                                                value={mainProvidereModal.StateLicenseNumber}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div><div className="col-md-3">
                                        <div className='input'>
                                            <label>Dea#</label>
                                            <input type="text"
                                                maxLength={50}
                                                autoComplete="off"
                                                className="form-control"
                                                name="DEANum"
                                                id="DEANum"
                                                value={mainProvidereModal.DEANum}
                                                onChange={handleProviderChange} />
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        )
    }

    const handleRemoveFile = () => {
        let newData = {
            "SignatureFileName": '',
            "SignaturePath": ''
        }
        setmainProvidereModal(prev => ({ ...prev, ...newData }))
        setProviderSaveUpdateModal(prev => ({ ...prev, ...newData }))
        setImgFile(null);
        setModalImg(null);
    }
    const getSaveData = async (_, filename, base64) => {
        console.log("get Save Data Sign ,", filename, base64);
        let newData = {
            "SignatureFileName": filename,
            "SignaturePath": base64
        }
        setmainProvidereModal(prev => ({ ...prev, ...newData }))
        setProviderSaveUpdateModal(prev => ({ ...prev, ...newData }))
    }
    console.log("mainProvidereModalmainProvidereModal", mainProvidereModal)

    const ViewFile = (SignaturePath) => {
        if (!isNull(SignaturePath)) {
            // setPdfFile(null);
            // setTxtFile(null);
            setImgFile(null);
            setModalImg(null);
            setIsLoading(true);
            ServerRequestPublic(
                API_URL_Wasabi + "/DownloadFile",
                "post",
                {
                    BucketPath: SignaturePath,
                },
                "Download"
            )
                .then((response) => {
                    setIsLoading(false);

                    if (response.type === "application/txt") {
                        // const blob = response;
                        // const reader = new FileReader();
                        // reader.onload = () => {
                        //     const content = reader.result;
                        //     setTxtFile(content);
                        // };

                        // reader.readAsText(blob, "utf-8");
                    } else if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    } else if (response.type === "application/pdf") {
                        // const blob = response;
                        // const objectURL = URL.createObjectURL(blob);
                        // setPdfFile(objectURL);
                    } else {
                        // let file = new Blob([response]);
                        // const fileUrl = URL.createObjectURL(file);
                        // setPdfFile(fileUrl);
                    }
                    // setModalActive(true);
                })
                .catch((error) => {
                    setIsLoading(false);
                    NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
                });
        }
    };
    const providerName = [mainProvidereModal.FirstName, mainProvidereModal.LastName].filter(Boolean).join(' ');

    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            <Modal show={printoutModal} onHide={printoutModal} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_sign-preview">
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-end gap-2">
                        <i className="icon-x-cros dark-clr fs-20" onClick={() => {
                            setPrintOutModal(false);
                            setModalImg(null);
                        }}></i>
                    </div>
                    <div className='d-flex align-items-center justify-content-center pt-15'>
                        <img
                            src={modalImg}
                            style={{ maxHeight: '300px' }}
                            className="mw-100 px-2"
                            alt="Uploaded preview" />
                    </div>
                </Modal.Body>
            </Modal>
            <SignEncounter
                isSign={isSign}
                setIsSign={setIsSign}
                // providerName={mainProvidereModal.ProviderName}
                providerName={providerName}
                setSearchParam={() => { }}
                getSaveData={getSaveData}
                // item={item}
                isOpenedFrom={'AddNewProvider'}
            />
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    <div className="pb-15">
                        {AddNewProvModalBody()}
                    </div>
                    <ModalFooter isSaved={onProviderSaved ? onDeleteProvider : onClose} handleSave={handleSaveProvider} UpdatedDate={mainProvidereModal.UpdatedDate} UpdatedBy={mainProvidereModal.UpdatedBy} ID={providerID} IsEditAllowed={IsEditAllowed} />

                    {PopupScreen}
                    {providerID === 0 ?
                        <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                            <Modal.Body>
                                {/* <SearchHeader masterListButton={proceedNPI} /> */}
                                <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                                <div className='container-fluid  br-clr'>
                                    <div className="row">
                                        <div className={providerValidationModal.NPIVal ? 'input error' : providerValidationModal.NPILengthVal ? 'input error' : 'input'}>
                                            {/* <label htmlFor="">NPI</label> */}
                                            <div className='field-icon'>
                                                <input
                                                    className='form-control'
                                                    name="NPI"
                                                    id="NPI"
                                                    autoComplete="off"
                                                    autoFocus={true}
                                                    maxLength={10}
                                                    value={mainProvidereModal.NPI}
                                                    onChange={handleProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                            <button className="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry}>Proceed <i className="icon-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal> : null}
                </> : <>
                    <Modal autoFocus={false} show={isOpenProvider} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 dragger_btmNull">
                        {AuditPopup}
                        <Draggable handle=".hk-modal-header">
                            <Modal.Body>
                                <ModalHeader HeaderName={SetProviderName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onProviderSaved ? onDeleteProvider : onClose} key={613} Name={'Provider'} providerID={providerIDs.ProviderID} IsDeleteAllowed={IsDeleteAllowed} />
                                {AddNewProvModalBody()}
                                {PopupScreen}
                                <ModalFooter isSaved={onProviderSaved ? onDeleteProvider : onClose} handleSave={handleSaveProvider} UpdatedDate={mainProvidereModal.UpdatedDate} UpdatedBy={mainProvidereModal.UpdatedBy} ID={providerID} IsEditAllowed={IsEditAllowed} />
                            </Modal.Body>
                        </Draggable>
                    </Modal>
                    {providerID === 0 ?
                        <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                            <Modal.Body>
                                {/* <SearchHeader masterListButton={proceedNPI} /> */}
                                <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                                <div className='container-fluid  br-clr'>
                                    <div className="row">
                                        <div className={providerValidationModal.NPIVal ? 'input error' : providerValidationModal.NPILengthVal ? 'input error' : 'input'}>
                                            {/* <label htmlFor="">NPI</label> */}
                                            <div className='field-icon'>
                                                <input
                                                    className='form-control'
                                                    name="NPI"
                                                    id="NPI"
                                                    autoComplete="off"
                                                    autoFocus={true}
                                                    maxLength={10}
                                                    value={mainProvidereModal.NPI}
                                                    onChange={handleProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                            <button className="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry}>Proceed <i className="icon-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal> : null}
                </>}
            {DeleteConfirmation}

        </React.Fragment>
    )
}

export default AddNewProvider